import data from "../../shared/sharedData";

export default {
  name: "Attorney or Agent Information (if applicable)",
  pageInfo: {
    text: "The employer authorizes the attorney or agent identified in this section to act on its behalf in connection with the filing of this application.",
    coloring: "grey",
  },
  prefix: "E",
  sections: [
    {
      fields: [
        {
          widget: "inlinePrefiller",
          prefillLabel:
            "Select an Attorney/Agent profile to populate this section (optional)",
          prefill: {
            schema: "agentAttorney",
            type: "agent-attorney-individs",
            formName: "9035",
            formSection: "E",
          },
        },
        {
          isGroup: {
            code: "E.1",
            machine_name: "e1_is_represented",
            label:
              "Is the employer represented by an attorney or agent in the filing of this application?",
            tooltip:
              'Identify whether the employer is represented by an attorney or agent in the process of filing this application. Only mark one box. If “Attorney” or "Agent" complete the remainder of Section E. If “None” in question 1, skip 2 through 19 and continue to Section F.<br><strong>Note:</strong> If “Attorney”, complete questions 2 to 19 in Section E.  If “Agent”, complete questions 2 to 17.  Associations filing H-2A applications as an agent on behalf of one or more of its grower members must mark “Agent” and complete this section with the association’s information.  If “None”, skip questions 2 to 19 and continue to Section F',
            coloring: "none",
            required: true,
            fields: [
              {
                widget: "radio",
                choice: "Attorney",
                value: "Attorney",
                validate: ["required"],
              },
              {
                widget: "radio",
                choice: "Agent",
                value: "Agent",
                validate: ["required"],
              },
              {
                widget: "radio",
                choice: "None",
                value: "None",
                validate: ["required"],
                clearSchema: [
                  "e2_agent_last",
                  "e3_agent_first",
                  "e4_agent_middle",
                  "e5_agent_address_1",
                  "e6_agent_address_2",
                  "e10_agent_country_id",
                  "e7_agent_city",
                  "e8_agent_state_id",
                  "e11_agent_province",
                  "e9_agent_zip",
                  "e12_agent_phone",
                  "e13_agent_phone_ext",
                  "e14_agent_email",
                  "e15_agent_firm_name",
                  "e16_agent_firm_fein",
                  "e17_agent_bar_number",
                  "e18_agent_court_state_id",
                  "e19_agent_court_name",
                ],
              },
            ],
          },
        },
      ],
    },
    {
      isVisible: {
        when: "e1_is_represented",
        is: ["Attorney", "Agent"],
        operator: "||",
      },
      fields: [
        {
          code: "E.2",
          machine_name: "e2_agent_last",
          widget: "text",
          label: "Attorney or Agent's Last (family) Name",
          validate: [
            "required",
            {
              minLength: 2,
              message:
                "Attorney or Agent's Last Name must contain at least 2 characters.",
            },
          ],
          maxLength: 35,
          tooltip: "Enter the last (family) name of the attorney/agent.",
        },
        {
          code: "E.3",
          machine_name: "e3_agent_first",
          widget: "text",
          label: "First (given) Name",
          validate: [
            "required",
            {
              minLength: 2,
              message: "First Name must contain at least 2 characters.",
            },
          ],
          maxLength: 35,
          tooltip: "Enter the first (given) name of the attorney/agent.",
        },
        {
          code: "E.4",
          machine_name: "e4_agent_middle",
          widget: "text",
          label: "Middle Name(s)",
          maxLength: 35,
          tooltip:
            "Enter the middle name of the attorney/agent, if a middle name exists.",
        },
      ],
    },
    {
      isVisible: {
        when: "e1_is_represented",
        is: ["Attorney", "Agent"],
        operator: "||",
      },
      fields: [
        {
          code: "E.5",
          machine_name: "e5_agent_address_1",
          widget: "text",
          label: "Address 1",
          validate: [
            "required",
            {
              minLength: 5,
              message: "Address 1 must contain at least 5 characters.",
            },
          ],
          maxLength: 60,
          tooltip: "Enter the street address of the attorney/agent.",
        },
        {
          code: "E.6",
          machine_name: "e6_agent_address_2",
          widget: "text",
          label:
            "<span>Address 2 <i>(apartment/suite/floor and number)</i></span>",
          maxLength: 60,
          tooltip:
            "If additional space is needed for the street address, use this line to complete the attorney/agent’s street address.",
        },
        {
          code: "E.10",
          machine_name: "e10_agent_country_id",
          widget: "select",
          label: "Country",
          selection: data.country,
          clearSchema: ["e8_agent_state_id", "e11_agent_province"],
          validate: ["required"],
          tooltip:
            "Enter the country of the attorney/agent. If the city and country are the same, the name must still be entered in both fields.",
        },
        {
          code: "E.7",
          machine_name: "e7_agent_city",
          widget: "text",
          label: "City",
          validate: [
            "required",
            {
              minLength: 2,
              message: "City must contain at least 2 characters.",
            },
          ],
          maxLength: 35,
          disabled: true,
          disableWhenField: "e10_agent_country_id",
          tooltip:
            "Enter the city of the attorney/agent. If the city and country are the same, the name must still be entered in both fields.",
        },
        {
          code: "E.8",
          machine_name: "e8_agent_state_id",
          widget: "select",
          label: "State",
          selection: data.state,
          validate: ["required"],
          disabled: true,
          disableWhenField: "e10_agent_country_id",
          state: true,
          isVisible: {
            when: "e10_agent_country_id",
            is: ["UNITED STATES OF AMERICA", "- Select -", ""],
            operator: "||",
            hideStyles: true,
          },
          tooltip: "Enter the state of the attorney/agent.",
        },
        {
          code: "E.11",
          machine_name: "e11_agent_province",
          widget: "text",
          label: "Province",
          maxLength: 25,
          validate: [
            {
              isRequired: "e10_agent_country_id",
              message: "This field is required",
              needsFieldValues: true,
              extraData: {
                valueOf: "CANADA",
              },
            },
            {
              minLength: 5,
              message: "Province must contain at least 5 characters.",
            },
          ],
          isVisible: {
            when: "e10_agent_country_id",
            is: ["UNITED STATES OF AMERICA", "- Select -", ""],
            operator: "!==",
            hideStyles: true,
          },
          tooltip: "Enter the province of the attorney/agent, if applicable.",
        },
        {
          code: "E.9",
          machine_name: "e9_agent_zip",
          widget: "text",
          label: "Postal Code",
          validate: [
            "required",
            {
              postalCountry: "e10_agent_country_id",
              needsFieldValues: true,
              extraData: {
                valueOf: "e10_agent_country_id",
              },
            },
          ],
          disabled: true,
          disableWhenField: "e10_agent_country_id",
          maxLength: 10,
          tooltip: "Enter the postal (zip) code of the attorney/agent.",
        },
      ],
    },
    {
      isVisible: {
        when: "e1_is_represented",
        is: ["Attorney", "Agent"],
        operator: "||",
      },
      fields: [
        {
          code: "E.12",
          machine_name: "e12_agent_phone",
          widget: "phone",
          label: "Telephone Number",
          validate: ["required", "phone"],
          warning: {
            text: "Please verify the information entered for accuracy. In accordance with OMB approved instructions, the attorney/agent information contained in this section, specifically the name, telephone number, and email address, must be different from the employer's point of contact information in Section C of this application, unless the person named in this section is an employee of the employer.",
            isVisible: {
              when: "c12_poc_phone",
              is: "e12_agent_phone",
              operator: "compareFieldValues",
            },
          },
          tooltip:
            "Enter the area code and telephone number of the attorney/agent. Include country code, if applicable.",
        },
        {
          code: "E.13",
          machine_name: "e13_agent_phone_ext",
          widget: "text",
          label: "Extension",
          validate: ["number"],
          parse: "positiveWholeNumber", //don't allow decimal Number and negative number
          maxLength: 4,
          tooltip:
            "Enter the extension of the telephone number of the attorney/agent, if applicable.",
        },
        {
          code: "E.14",
          machine_name: "e14_agent_email",
          widget: "text",
          label: "Email Address",
          validate: [
            "required",
            {
              email: {
                extraData: {
                  allowNAs: true,
                },
              },
            },
          ],
          maxLength: 100,
          warning: {
            text: "The employer point of contact must be different from the agent/attorney, unless the agent/attorney is an employee of the employer.",
            isVisible: {
              when: "d14_poc_email",
              is: "e14_agent_email",
              operator: "compareFieldValues",
            },
          },
          tooltip:
            "Enter the business e-mail address of the attorney/agent. Use a name@emailaddress.top-leveldomain format.",
        },
        {
          code: "E.15",
          machine_name: "e15_agent_firm_name",
          widget: "text",
          label: "Law Firm/Business Name",
          validate: [
            "required",
            {
              minLength: 5,
              message:
                "Law Firm/Business Name must contain at least 5 characters",
            },
          ],
          maxLength: 120,
          tooltip: "Enter the attorney/agent’s law firm or business name.",
        },
        {
          code: "E.16",
          machine_name: "e16_agent_firm_fein",
          widget: "text",
          label: "Law Firm/Business FEIN",
          disableWhenField: {},
          validate: [
            "fein",
            { minLength: 10, message: "This is not a valid FEIN" },
            {
              FEINPrefixValidator: "e16_agent_firm_fein",
              needsFieldValues: true,
              message:
                "Please enter a valid 1st 2 digits of the Agent or Attorney's 9 digit Federal Employer Identification number(FEIN).",
              extraData: {
                condition: {
                  when: "e10_agent_country_id",
                  value: "UNITED STATES OF AMERICA",
                },
              },
            },
          ],
          parse: "fein",
          maxLength: 10,
          tooltip:
            "Enter the attorney/agent's law firm or business nine-digit FEIN as assigned by the IRS. Do not enter a social security number. Law firms or businesses in countries other than the United States may leave this field blank.",
          warning: {
            text: "The information provide in this Section must be different from the employer's information unless the attorney is an employee of the employer.",
            isVisible: {
              when: "c12_emp_fein",
              is: "e16_agent_firm_fein",
              operator: "compareFieldValues",
            },
          },
        },
      ],
    },
    {
      isVisible: {
        when: "e1_is_represented",
        is: "Attorney",
      },
      fields: [
        {
          code: "E.17",
          machine_name: "e17_agent_bar_number",
          widget: "text",
          label: "State Bar Number",
          validate: ["required"],
          maxLength: 35,
          tooltip:
            "Enter the attorney's State Bar number. If the attorney is licensed in more than one State, enter only one State Bar number. If the attorney is licensed in a state which does not issue State Bar numbers, enter “N/A”.Note: The answers to questions 18 and 19 below should correspond to the same state for which a Bar number was provided in question 17, if any.",
        },
        {
          code: "E.18",
          machine_name: "e18_agent_court_state_id",
          widget: "select",
          label:
            "State of highest state court where attorney is in good standing",
          selection: data.state,
          validate: ["required"],
          tooltip:
            "Enter the State of the highest court where the attorney is in good standing.",
        },
        {
          code: "E.19",
          machine_name: "e19_agent_court_name",
          widget: "text",
          label:
            "Name of highest state court where attorney is in good standing",
          maxLength: 55,
          validate: ["required"],
          tooltip:
            "Enter the name of the highest State court where attorney is in good standing.",
        },
      ],
    },
  ],
};
